// 3D 模式的图像处理 20191125 MIPS3D版本

// 引用
import { initMap, getMap } from './Map/Map'
import { addLayer, removeLayer, setLayerParams, addLonLatGird, removeLonLatGird, setSatelliteParams } from './Layer/Layer'
import { getExistLayerList } from './Layer/layerStatusControl'
import { setGeojsonLayerStyle } from './Layer/getGeojsonLayer'
import { getLayerZIndex } from './Layer/layerZIndexControl'
import {
  getCameraCenterPosition,
  getCameraCurrentExtent
} from './Camera/getPosition'
import { setViewByLookAt, setCameraBySetView, setCameraflyTo } from './Camera/setCamera'
// 添加 基于 view 的部分
import { setViewMode } from './Map/View'
import { setLonLatMoveListener, removeLonLatMoveListener, setReslutionListener } from './Event/index'

import { beginEarthRotation, stopEarthRotation } from './Action/setEarthRotation'

import util from './util/util'

function ShinetekView3D (config) {
  var self = this

  // 对初始化参数进行处理
  self.initParams = config

  // 初始化Map
  self.initMap = initMap
  self.getMap = getMap

  // 图层操作
  self.addLayer = addLayer
  self.removeLayer = removeLayer
  // 修改 geojson 图层样式
  self.setGeojsonLayerStyle = setGeojsonLayerStyle
  self.getExistLayerList = getExistLayerList

  // 镜头操作 获取 当前视角
  self.getCameraCenterPosition = getCameraCenterPosition
  self.getCameraCurrentExtent = getCameraCurrentExtent

  // 视角控制部分
  self.setViewByLookAt = setViewByLookAt
  self.setCameraBySetView = setCameraBySetView

  // 控制切换
  self.setViewMode = setViewMode

  // 属性设置
  self.setLayerParams = setLayerParams

  // 图层 zindex 控制
  self.getLayerZIndex = getLayerZIndex

  // 事件
  self.setLonLatMoveListener = setLonLatMoveListener
  self.removeLonLatMoveListener = removeLonLatMoveListener
  self.setReslutionListener = setReslutionListener

  // 经纬度网格
  self.addLonLatGird = addLonLatGird
  self.removeLonLatGird = removeLonLatGird

  // 修改卫星位置
  self.setSatelliteParams = setSatelliteParams

  self.setCameraflyTo = function (info) {
    // 设置 setCameraflyTo
    setCameraflyTo(info, self)
  }

  /**
   * 开始自转
   * @param {Number} speed 自转速率 默认10 1为1单位自转速度
   * @example
   *  const value = 110
   *  // 开始自转 如果重复调用 则 使用新系数
   *  m3DMapClass.beginEarthRotation(value)
   */
  self.beginEarthRotation = function (speed) {
    beginEarthRotation(speed, self)
  }

  /**
   * 结束自转
   * @example
   * m3DMapClass.stopEarthRotation()
   */
  self.stopEarthRotation = function () {
    stopEarthRotation(self)
  }

  /**
   * 设置时间轴当前时间
   * @param {Date} newDate 新时间
   */
  self.setCurrentTime = function (newDate) {
    util.setCurrentTime(newDate, self)
  }

  /**
   * 设置时间轴显示状态 todo
   */
  self.setTimeLineStatus = function () {
    util.setTimeLineStatus(self)
  }

  /**
   * 设置时间状态 true 为动画开始 false 为动画结束
   * @param {Bool} shouldAnimate shouldAnimate 状态
   */
  self.setAnimateStatus = function (shouldAnimate) {
    util.setAnimateStatus(shouldAnimate, self)
  }

  self.openLighting = function () {
    util.openLighting(self)
  }

  self.closeLighting = function () {
    util.closeLighting(self)
  }

  self.setLighting = function (date) {
    util.setLighting(date, self)
  }

  self.openAtmosphere = function () {
    util.openAtmosphere(self)
  }

  self.closeAtmosphere = function () {
    util.closeAtmosphere(self)
  }

  self.setMapBackground = function (type) {
    util.setMapBackground(type, self)
  }

  self.setSunMoonStatus = function (status) {
    util.setSunMoonStatus(status, self)
  }
}

window.ShinetekView3D = ShinetekView3D
export default ShinetekView3D
